
import React, { useState } from "react";
import ButtonComponent from '../shared/button/button.component'
import { buttonLabels, ToasterTexts } from '../shared/constants'
import { ChannelAccountModel, ChannelType, ChannelAccountStatus as ChannelStatusType, ChannelAccountStatus } from '../../models/channels/channels.model';
import setToast from '../../helpers/toaster.helper';
import { ChannelService } from '../../services/channels/ChannelAcountService';
import { ToasterType } from '../shared/toaster/toaster.model';
import { LoadChannels } from '../../actions';
import { mapToUser } from "../../models/conversations";
import { ChannelUserModel, mapToChannelUser, UserModel } from "../../models/users.model";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { Dialog, DialogContent, DialogTitle, Grid, TextField, Tooltip } from "@mui/material";
import { BackIcon, CancelIcon } from "../../icon";


interface IProps {
    Show: boolean;
    CloseEditChannel: () => void;
    Channel?: ChannelAccountModel;
}

const EditChannelComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [channel, setChannel] = useState<ChannelAccountModel>({
        ...(props.Channel || {
            Name: "",
            NickName: "",
            ID: "",
            ChannelType: 0 as ChannelType,
            Status: 0 as ChannelAccountStatus,
            UpdatedDate: "",
            UpdatedByID: "",
            CreatedByID: "",
            CreatedDate: "",
        } as ChannelAccountModel)
    });

    const handleChange = (e: any) => {
        if (e.target.value) {
            setChannel({ ...channel, NickName: e.target.value })

        }
        else {
            setChannel({ ...channel, NickName: "" })
        }
    };

    const formSubmit = (event: any) => {
        event.preventDefault();
        setIsLoading(true);
        let obj: any = {
            "id": channel.ID,
            "nick_name": channel.NickName,
            "name": channel.Name,
            "channel": channel.ChannelType,
            "status": channel.Status,
            "updated_by": channel.UpdatedByID,
            "created_by": channel.CreatedByID,
        }
        let Name = channel.NickName;

        const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;


        // var user = JSON.parse(localStorage.getItem('current-user')!);
        ChannelService.updateChannelAccount(user.OrganizationID, channel.ID, obj)
            .then(() => {
                setToast(ToasterTexts.NICK_NAME_UPDATE_SUCCESS.replace('<Name>', Name), ToasterType.SUCCESS)
                setIsLoading(false);
                LoadChannels(dispatch, user.OrganizationID)
                props.CloseEditChannel();
            })
            .catch((err) => {
                setIsLoading(false);
            });
    }

    return (
        <div>
            {IsMobileDevice ?
                <div className="paper-background o-x-hidden w-fill h-v-100">
                    <Grid item xs={12}>
                        <div className='box-shadow-display-background-shadow d-flex p-2'>
                            {IsMobileDevice && <span><BackIcon className={"c-pointer pr-2"} onClick={props.CloseEditChannel} /></span>}
                            <span className={`h1 my-auto color-add-details-title mr-auto`}>{channel.NickName}</span>
                        </div>
                    </Grid>
                    <form
                        noValidate
                        autoComplete="no"
                        onSubmit={formSubmit}
                        className="m-2 h-v-65"
                    >
                        <Grid item xs={12}>
                            <TextField
                                autoFocus
                                placeholder="NickName"
                                label="NickName"
                                variant="outlined"
                                size="small"
                                name="NickName"
                                required
                                fullWidth
                                value={channel.NickName}
                                className="w-p-97 ml-1"
                                onChange={(e) => handleChange(e)}
                            />
                        </Grid>
                    </form>
                    <div className={`px-2 mt-auto`}>
                        <ButtonComponent OnClick={formSubmit} ButtonLabel={buttonLabels.UPDATE.toUpperCase()} Loading={isLoading} ClassName={"w-p-100 justify-center mb-2 br-6"} Variant={"primary-btn-small"} />
                        <ButtonComponent OnClick={() => props.CloseEditChannel()} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={"w-p-100 justify-center mb-2 br-6"} Variant={"secondary-btn-small"} />
                    </div>
                </div> :
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    onClose={() => props.CloseEditChannel()}
                    aria-labelledby="responsive-dialog-title"
                    open={props.Show}
                    BackdropProps={{
                        style: { backgroundColor: "transparent" },
                    }}
                    className={"dialogue-shadow"}
                    disableEscapeKeyDown
                >
                    <DialogTitle className="dialog-header" >
                        <div className={`h2-regular color-display-title d-flex ml-1`} id="customized-dialog-title">
                            {"Edit Page name"}
                            <Tooltip title="Close" placement="bottom">
                                <span className="ml-auto mr-1">
                                    <CancelIcon className={"c-pointer"} onClick={() => props.CloseEditChannel()} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <DialogContent className={"o-hidden pt-2"}>
                        <TextField
                            autoFocus
                            placeholder="NickName"
                            label="NickName"
                            variant="outlined"
                            size="small"
                            name="NickName"
                            required
                            fullWidth
                            value={channel.NickName}
                            className="w-p-97 ml-1"
                            onChange={(e) => handleChange(e)}
                        />
                        <div className="d-flex my-2">
                            <ButtonComponent OnClick={formSubmit} Loading={isLoading} Type={"submit"} ButtonLabel={buttonLabels.UPDATE} ClassName={"px-4 ml-auto"} Variant={"primary-btn-small"} />
                            <ButtonComponent OnClick={() => props.CloseEditChannel()} ButtonLabel={buttonLabels.CANCEL} ClassName={"mr-1 ml-2"} Variant={"secondary-btn-small"} />
                        </div>
                    </DialogContent>
                </Dialog>
            }
        </div>
    )
}


export default EditChannelComponent;
